module.exports = __webpack_public_path__ + "pc/img/01_Research-Strategy.33dbf351.png";